import estyled from '@signal/theme/emotion'
import Dialog from '@material-ui/core/Dialog'
import Grow from '@material-ui/core/Grow'
import { getSpacingSelector } from '@signal/theme/selectors'

type PromptDialogType = typeof Dialog.prototype & {
  $zIndexOverride?: number
}

export const PromptDialog = estyled<PromptDialogType>(Dialog).attrs(() => ({
  TransitionComponent: Grow
}))`
  ${({ $zIndexOverride }) =>
    $zIndexOverride ? `z-index: ${$zIndexOverride} !important;` : ''}

  & .MuiDialogActions-root {
    ${({ $actionPaddingOverride }) =>
      $actionPaddingOverride
        ? `padding: ${$actionPaddingOverride} !important;`
        : ''}
  }

  & .MuiDialogTitle-root {
    ${({ $titlePaddingOverride }) =>
      $titlePaddingOverride
        ? `padding: ${$titlePaddingOverride} !important;`
        : ''}
  }

  & .MuiDialogContent-root {
    ${({ $contentPaddingOverride }) =>
      $contentPaddingOverride
        ? `padding: ${$contentPaddingOverride} !important;`
        : ''}
  }

  & .MuiPaper-root {
    padding: ${getSpacingSelector(2)}px;

    ${({ $maxWidthOverride }) =>
      $maxWidthOverride ? `max-width: ${$maxWidthOverride} !important;` : ''}
  }
`

export const DescriptionWrapper = estyled.div`
  display: flex;
  align-items: center;

  & svg {
    display: block;
    font-size: 64px !important;
    margin-right: ${getSpacingSelector(2)}px;
  }
`
